
















import moment from "moment";
import "moment/locale/fr";
import MobileMixin from "@/mixins/mobileMixin";
import Component, { mixins } from "vue-class-component";
import ErrorMixin from "@/mixins/errorMixins";
import { Watch } from "vue-property-decorator";
import { Route } from "vue-router";

@Component
export default class App extends mixins(MobileMixin, ErrorMixin) {
  public myHeight = window.innerHeight + "px";

  public mounted() {
    const vh = window.innerHeight;
    // document.documentElement.style.setProperty("--vh", `${vh}px`);
    this.$store.dispatch("init");

    // Vérifie la langue dans le store login
    if (this.$store.getters["login/language"] === "") {
      // La langue n'est pas définie dans le store
      moment.locale("fr");
      this.$store.dispatch("login/setLanguage", "fr");
    } else {
      moment.locale(this.$store.getters["login/language"]);
      this.$i18n.locale = this.$store.getters["login/language"];
    }

    document.addEventListener("deviceready", () => {
      // this.onDeviceReady();
      // alert("ready");
    });
    return { locale: "fr" };
  }

  public getAllReports() {
    this.$store
      .dispatch("rapport/getAllReports")
      .then((rapports) => {
        // console.log(rapports);
      })
      .catch((error: any) => {
        this.$store.dispatch("login/setLoading", false);
        this.setErrorFromTxt(this.$t("ErrorGettingAllReport").toString());
      });
  }

  @Watch("$route", { immediate: true, deep: true })
  public onUrlChange(newVal: Route) {
    // console.log("change detected");
    this.clearNotif();
  }
}
